export default "__VITE_ASSET__BXDRL1rN__"